import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"

import { wownetApi } from "@shared/apis"
import { WownetEvent } from "@shared/apis/wownet"
import { useSchedule } from "@shared/contexts"

import Thumbnail from "../quickMenu/Thumbnail"

export default function EventPopup() {
  const { schedule } = useSchedule()
  const [event, setEvent] = useState<WownetEvent | null>(null)
  const [isShow, setIsShow] = useState<boolean>(true)

  const streamerUsername = schedule?.user.username
  const quickMenu = document.querySelector(".quickMenuB") as HTMLElement

  useEffect(() => {
    if (!streamerUsername) return

    wownetApi
      .getPartnerEvent(streamerUsername)
      .then((res) => setEvent(res.data))
  }, [streamerUsername])

  if (!event?.imageUrl || !event?.linkUrl) {
    return null
  }

  return (
    <>
      {isShow && (
        <div className="eventPop">
          <div className="inner">
            <a href={event.linkUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={event.imageUrl}
                alt="이벤트팝업"
                style={{
                  width: 339,
                  height: 339,
                  objectFit: "contain",
                  objectPosition: "50% top",
                }}
              />
            </a>
            <button className="btnClose" onClick={() => setIsShow(false)}>
              <span>닫기</span>
            </button>
          </div>
        </div>
      )}
      {quickMenu &&
        createPortal(
          <Thumbnail src={event.imageUrl} link={event.linkUrl} />,
          quickMenu,
        )}
    </>
  )
}
